import { useForm } from 'react-hook-form'
import { Link } from 'react-router'

import { yupResolver } from '@hookform/resolvers/yup'
import { SigninCredentialsPayload, SignupPageStatus } from '@ui/interfaces'
import useAppNavigation from '@ui/lib/hooks/useAppNavigation'
import { useAuth } from '@ui/providers/AuthProvider'
import { RouteNamesEnum } from '@ui/router/routes'
import * as Yup from 'yup'

import { UpdatePageStatus } from '../Login'

const defaultValues = import.meta.env.DEV
  ? {
      email: 'admin@datable.io',
      password: 'Datable12345!',
    }
  : undefined

type LoginFormProps = {
  setPageStatus: UpdatePageStatus
}

export function LoginForm(props: LoginFormProps) {
  const { setPageStatus } = props
  const { navigateTo } = useAppNavigation()

  const auth = useAuth()

  const schema = Yup.object({
    email: Yup.string().email().required('Email required'),
    password: Yup.string().required('Please enter your password'),
  })

  const {
    register,
    handleSubmit,
    setError,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
    defaultValues,
  })
  const sendToServer = async ({ email, password }: { email: string; password: string }) => {
    const configuration: SigninCredentialsPayload = {
      user: { email, password },
    }

    auth.signinWithPassword(configuration, (error: any, response) => {
      if (error || !response) {
        const { data } = error
        const errors = data?.errors || ['Invalid email or password']

        setError('email', { message: errors.join(', ') })
      } else {
        setPageStatus(SignupPageStatus.SUCCESS, () => {
          setTimeout(() => {
            if (response?.instance?.connect_key) {
              navigateTo(RouteNamesEnum.EVENTS_EXPLORER, { instanceId: response?.instance?.connect_key })
            } else {
              navigateTo(RouteNamesEnum.INSTANCES)
            }
          }, 2000)
        })
      }
    })
  }
  return (
    <div className={'h-fit w-full py-10'}>
      <form onSubmit={handleSubmit(sendToServer)} className="text-left">
        <div>
          <label htmlFor="email" className="text-sm text-gray-700">
            Email
          </label>
          <input
            {...register('email')}
            type="text"
            name="email"
            id="email"
            className="mt-2 block w-full rounded-md border-0 bg-white text-gray-600 shadow-sm outline-none ring-2 ring-inset ring-gray-200 transition-all duration-300 ease-in-out placeholder:text-gray-500 focus:ring-2 focus:ring-inset focus:ring-primary-200 sm:text-sm sm:leading-6"
            placeholder="name@company.com"
          />
          {errors.email && <p className="mt-2 text-xs italic text-red-500">{errors.email?.message}</p>}
        </div>
        <div>
          <label htmlFor="password" className="text-sm text-gray-700">
            Password
          </label>
          <input
            {...register('password')}
            type="password"
            name="password"
            id="password"
            className="mt-2 block w-full rounded-md border-0 bg-white text-gray-600 shadow-sm outline-none ring-2 ring-inset ring-gray-200 transition-all duration-300 ease-in-out placeholder:text-gray-500 focus:ring-2 focus:ring-inset focus:ring-primary-200 sm:text-sm sm:leading-6"
          />
          {errors.password && <p className="mt-2 text-xs italic text-red-500">{errors.password?.message}</p>}
        </div>
        <button
          type="submit"
          className="mt-8 w-full rounded-md bg-primary-500 px-3 py-2 text-sm font-semibold text-white shadow-sm transition-colors duration-300 ease-in-out hover:bg-primary-600 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary-600">
          Sign in
        </button>

        <div className="flex flex-col items-center pb-6 pt-4 text-sm">
          <div className="pb-2">
            Need an account?{' '}
            <Link
              to="/signup"
              key="signup"
              onClick={() => setPageStatus(SignupPageStatus.SIGNUP)}
              className="cursor-pointer pl-1 text-primary-500 transition-all duration-300 ease-in-out hover:font-medium hover:text-primary-700">
              Signup
            </Link>
          </div>
          <div>
            Forgot your password?
            <Link
              to="/forgot"
              onClick={() => setPageStatus(SignupPageStatus.FORGOT)}
              className="cursor-pointer pl-1 text-primary-500 transition-all duration-300 ease-in-out hover:font-medium hover:text-primary-700">
              Reset your password
            </Link>
          </div>
        </div>
      </form>
    </div>
  )
}
